import { MessageCircle, MessageSquare, Mic, Smartphone } from 'lucide-react'
import React from 'react'

const Feature = () => {
  return (
     <section className="py-20 bg-white" id="features">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Everything you need to communicate effectively
            </h2>
            <p className="text-xl text-gray-600">
              Comprehensive messaging solutions with AI intelligence built-in
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-blue-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
                <MessageCircle className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                SMS Messaging
              </h3>
              <p className="text-gray-600">
                Reliable SMS delivery with global reach and high deliverability
                rates
              </p>
            </div>

            <div className="bg-green-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center mb-6">
                <Smartphone className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                WhatsApp Business
              </h3>
              <p className="text-gray-600">
                Rich media messaging with WhatsApp's 2B+ user base for enhanced
                engagement
              </p>
            </div>

            <div className="bg-purple-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <MessageSquare className="w-6 h-6 text-purple-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                RCS Messaging
              </h3>
              <p className="text-gray-600">
                Next-gen messaging with interactive cards, buttons, and rich
                media support
              </p>
            </div>

            <div className="bg-orange-50 p-8 rounded-2xl">
              <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                <Mic className="w-6 h-6 text-orange-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Voice Channels
              </h3>
              <p className="text-gray-600">
                AI-powered voice messaging and automated calling solutions
              </p>
            </div>
          </div>
        </div>
      </section>
  )
}

export default Feature